import React, { useMemo, useState, useRef, useEffect } from "react";
import "../styles/Pages.css";
import "../styles/Vachanamrut.css";
import "../styles/Shikshapatri.css";
import { shikshapatriMukhpathData } from "../data/shikshapatriMukhpathData";

function ShikshapatriMukhpath() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [search, setSearch] = useState("");
  const [fontSize, setFontSize] = useState(1);
  const activeRef = useRef(null);

  const normalizeLines = useMemo(
    () => (value) => {
      if (Array.isArray(value)) return value;
      if (typeof value === "string")
        return value
          .split("<br>")
          .map((l) => l.trim())
          .filter(Boolean);
      return [];
    },
    [],
  );

  const currentVerse = shikshapatriMukhpathData[currentIndex];
  const totalVerses = shikshapatriMukhpathData.length;

  const filtered = shikshapatriMukhpathData.filter((v) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      String(v.number).includes(q) ||
      (typeof v.sanskrit === "string" &&
        v.sanskrit.toLowerCase().includes(q)) ||
      (typeof v.gujarati === "string" && v.gujarati.toLowerCase().includes(q))
    );
  });

  useEffect(() => {
    activeRef.current?.scrollIntoView({ block: "nearest" });
  }, [currentIndex]);

  return (
    <main className="page-content vachanamrut-page scripture-reader">
      <section className="page-header">
        <h1 className="section-title">Shikshapatri Mukhpath</h1>
        <p className="header-subtitle">શિક્ષાપત્રી મુખપાઠ</p>
      </section>

      <div className="vachanamrut-layout">
        <div className="vachanamrut-body">
          {/* ── Left: shlok list ── */}
          <aside className="vachanamrut-list-panel">
            <input
              className="vachanamrut-search"
              type="text"
              placeholder="Filter shlok…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <ul className="vachanamrut-list">
              {filtered.map((v) => {
                const isActive = v.number === currentVerse.number;
                const firstLine = normalizeLines(v.sanskrit)[0] || "";
                const firstGuj = normalizeLines(v.gujarati)[0] || "";
                return (
                  <li
                    key={v.number}
                    ref={isActive ? activeRef : null}
                    className={`vachanamrut-item${isActive ? " active" : ""}`}
                    aria-current={isActive ? "true" : undefined}
                    onClick={() =>
                      setCurrentIndex(shikshapatriMukhpathData.indexOf(v))
                    }
                  >
                    <span className="vachan-name">Shlok {v.number}</span>
                    <span className="vachan-name-guj shiksha-preview">
                      {firstLine}
                    </span>
                    <span className="vachan-name-guj shiksha-preview shiksha-preview-guj">
                      {firstGuj}
                    </span>
                  </li>
                );
              })}
            </ul>
          </aside>

          {/* ── Right: Sanskrit then Gujarati ── */}
          <section className="vachanamrut-content-panel">
            <div className="vachan-meta">
              <span>
                Shlok {currentVerse.number} / {totalVerses}
              </span>
              <div className="font-resize-bar">
                <button
                  onClick={() => setFontSize((s) => Math.max(s - 0.15, 0.7))}
                >
                  A-
                </button>
                <button
                  onClick={() => setFontSize((s) => Math.min(s + 0.15, 2.5))}
                >
                  A+
                </button>
                <span>{Math.round(fontSize * 100)}%</span>
              </div>
            </div>

            <div className="shiksha-section">
              <h2 className="shiksha-lang-title">Sanskrit</h2>
              <div
                className="shiksha-text shiksha-sanskrit"
                style={{ fontSize: `${fontSize}em` }}
              >
                {normalizeLines(currentVerse.sanskrit).map((line, i) => (
                  <p key={i}>{line}</p>
                ))}
              </div>
            </div>

            <div className="shiksha-section">
              <h2 className="shiksha-lang-title">Gujarati</h2>
              <div
                className="shiksha-text shiksha-gujarati"
                style={{ fontSize: `${fontSize}em` }}
              >
                {normalizeLines(currentVerse.gujarati).map((line, i) => (
                  <p key={i}>{line}</p>
                ))}
              </div>
            </div>

            <nav className="shiksha-nav">
              <button
                onClick={() => setCurrentIndex((p) => Math.max(p - 1, 0))}
                disabled={currentIndex === 0}
              >
                ‹ Previous
              </button>
              <button
                onClick={() =>
                  setCurrentIndex((p) => Math.min(p + 1, totalVerses - 1))
                }
                disabled={currentIndex === totalVerses - 1}
              >
                Next ›
              </button>
            </nav>
          </section>
        </div>
      </div>
    </main>
  );
}

export default ShikshapatriMukhpath;
